export default __webpack_public_path__ + "static/media/caret_down.80b78e75.svg";